import * as monthUtils from '@actual-app/core/shared/months';
import type { Locale } from 'date-fns';
import type { TFunction } from 'i18next';

import type { ConfigNomina, PagaExtra } from './nomina';

/**
 * Nombre de la paga para ir dentro de una frase: «paga de verano», «paga de
 * Navidad», «paga de beneficios», «paga extra (marzo)» o el nombre propio.
 * Al principio de frase, con `mayuscula`.
 */
export function nombrePaga(t: TFunction, paga: PagaExtra, locale?: Locale) {
  if (paga.nombre) {
    return paga.nombre;
  }
  switch (paga.id) {
    case 'verano':
      return t('summer extra payment');
    case 'navidad':
      return t('Christmas extra payment');
    case 'beneficios':
      return t('profit share payment');
    default:
      return t('extra payment ({{month}})', {
        month: nombreMes(paga.mes, locale),
      });
  }
}

/** Nombre del mes (1..12) en el idioma de la app («junio»). */
export function nombreMes(mes: number, locale?: Locale) {
  return monthUtils.format(
    `2026-${String(mes).padStart(2, '0')}`,
    'MMMM',
    locale,
  );
}

/** «14 pagas», «12 pagas prorrateadas»… para la fila de Ajustes. */
export function resumenNomina(t: TFunction, config: ConfigNomina | null) {
  if (!config) {
    return t('Not set');
  }
  if (config.tipo === 'prorrateadas') {
    return t('Prorated pay');
  }
  return t('{{count}} payments', { count: 12 + config.pagas.length });
}

/** Primera letra en mayúscula (para frases que empiezan por el nombre). */
export function mayuscula(texto: string) {
  return texto.charAt(0).toLocaleUpperCase() + texto.slice(1);
}
